import React from "react";
import Login from "./Login";

const LoginRoute = () => {
  return <Login />;
};

export default LoginRoute;
